import Box from '@elementor/ui/Box';
import { styled } from '@elementor/ui/styles';
import { memo } from 'react';
import { StyledSkeleton } from '@styles/app.styles';

const StepSubscriptionFormLoader = memo(function StepSubscriptionFormLoader() {
	return (
		<StyledContainer>
			<StyledSkeleton width={'100%'} height={220} />

			<StyledSkeleton width={'75%'} height={40} sx={{ mt: 2 }} />

			<StyledSkeleton width={'72%'} height={20} />
			<StyledSkeleton width={'68%'} height={20} />

			<StyledFieldsContainer>
				<StyledSkeleton height={60} />
				<StyledSkeleton height={60} />
				<StyledSkeleton height={60} />
				<StyledSkeleton height={60} />
			</StyledFieldsContainer>

			<StyledSkeleton width={'100%'} height={42} sx={{ mt: 3 }} />
		</StyledContainer>
	);
});

const StyledContainer = styled(Box)`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	gap: ${({ theme }) => theme.spacing(1)};
`;

const StyledFieldsContainer = styled(Box)`
	width: 100%;

	display: grid;
	grid-template-columns: 1fr 1fr;
	justify-content: center;

	margin-top: ${({ theme }) => theme.spacing(2)};
	gap: ${({ theme }) => theme.spacing(2)};
`;

export default StepSubscriptionFormLoader;
